import styled from 'styled-components'

export const StyledProjectDetailsDialogContent = styled.div`
    display: grid;
    grid-template-rows: auto minmax(0, 380px) auto;
`
